import React from "react";
import PropTypes from "prop-types";
import Loader from "../../components/ui/Loader";

import DashboardCard1 from "../../assets/icons/dashboard-card-1.svg";
import DashboardGroup14 from "../../assets/icons/Data-load.svg";
const URLString = "trendsAndBenchmarking";

function ChartLoader({ loadingViewData }) {
    return (
        <div className="dashboard-images">
            <div className="card1-container">
                <img
                    src={DashboardCard1}
                    alt="Dashboard Card 1"
                    className="dashboard-img-full"
                />
                {loadingViewData ? (
                    <div className="card1-loader">
                        <Loader />
                    </div>
                ) : (
                    <>
                        <img
                            src={DashboardGroup14}
                            alt="Dashboard Group 14"
                            className="group14-image"
                        />
                        {window.location.href.includes(URLString) === false ? (
                            <div className="card1-text">
                                To get started, select<br></br>
                                an organization
                            </div>
                        ) : (
                            <div className="card1-text">
                                To see your data, make your<br></br>
                                selections and apply
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
ChartLoader.propTypes = {
    loadingViewData: PropTypes.bool,
};

export default ChartLoader;
